/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seller_Dashboard_Stat_Total_ViewsInputs */

const en_seller_dashboard_stat_total_views = /** @type {(inputs: Seller_Dashboard_Stat_Total_ViewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`total views`)
};

const es_seller_dashboard_stat_total_views = /** @type {(inputs: Seller_Dashboard_Stat_Total_ViewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`vistas totales`)
};

const fr_seller_dashboard_stat_total_views = /** @type {(inputs: Seller_Dashboard_Stat_Total_ViewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`vues totales`)
};

const de_seller_dashboard_stat_total_views = /** @type {(inputs: Seller_Dashboard_Stat_Total_ViewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesamtaufrufe`)
};

const ja_seller_dashboard_stat_total_views = /** @type {(inputs: Seller_Dashboard_Stat_Total_ViewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`総閲覧数`)
};

const zh_seller_dashboard_stat_total_views = /** @type {(inputs: Seller_Dashboard_Stat_Total_ViewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`总浏览量`)
};

const ar_seller_dashboard_stat_total_views = /** @type {(inputs: Seller_Dashboard_Stat_Total_ViewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إجمالي المشاهدات`)
};

const id_seller_dashboard_stat_total_views = /** @type {(inputs: Seller_Dashboard_Stat_Total_ViewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`total tayangan`)
};

const it_seller_dashboard_stat_total_views = /** @type {(inputs: Seller_Dashboard_Stat_Total_ViewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`visualizzazioni totali`)
};

const ru_seller_dashboard_stat_total_views = /** @type {(inputs: Seller_Dashboard_Stat_Total_ViewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`всего просмотров`)
};

const pt_seller_dashboard_stat_total_views = /** @type {(inputs: Seller_Dashboard_Stat_Total_ViewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`total de visualizações`)
};

const ko_seller_dashboard_stat_total_views = /** @type {(inputs: Seller_Dashboard_Stat_Total_ViewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`총 조회수`)
};

/**
* | output |
* | --- |
* | "total views" |
*
* @param {Seller_Dashboard_Stat_Total_ViewsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const seller_dashboard_stat_total_views = /** @type {((inputs?: Seller_Dashboard_Stat_Total_ViewsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seller_Dashboard_Stat_Total_ViewsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_seller_dashboard_stat_total_views(inputs)
	if (locale === "es") return es_seller_dashboard_stat_total_views(inputs)
	if (locale === "fr") return fr_seller_dashboard_stat_total_views(inputs)
	if (locale === "de") return de_seller_dashboard_stat_total_views(inputs)
	if (locale === "ja") return ja_seller_dashboard_stat_total_views(inputs)
	if (locale === "zh") return zh_seller_dashboard_stat_total_views(inputs)
	if (locale === "ar") return ar_seller_dashboard_stat_total_views(inputs)
	if (locale === "id") return id_seller_dashboard_stat_total_views(inputs)
	if (locale === "it") return it_seller_dashboard_stat_total_views(inputs)
	if (locale === "ru") return ru_seller_dashboard_stat_total_views(inputs)
	if (locale === "pt") return pt_seller_dashboard_stat_total_views(inputs)
	return ko_seller_dashboard_stat_total_views(inputs)
});